export default "__VITE_ASSET__Dv7gs91F__"